// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2cAJM","title":"Info_title__1Hkvd","selects":"Info_selects__pVyl3","requiredAsterisk":"Info_requiredAsterisk__ba6EE"};